import React, { FC } from "react";
import { GridRow } from "@getregistered/greg-editors";

export interface ResetButtonProps {
  selectedItems?: GridRow[];
  showResetAll?: boolean;
  onClick: () => void;
}

export const ResetButton: FC<ResetButtonProps> = ({
  selectedItems,
  showResetAll,
  onClick,
}) => {
  const handleResetAllClick = (e) => {
    if (confirm("Are you sure? This will reset badge print status for the whole event")) {
      onClick();
    }
  };

  const handleResetSelectedClick = () => {
    const count = selectedItems?.length ?? 0;
    if (
      confirm(
        `Reset ${count} selected badge${count === 1 ? "" : "s"}? This clears the printed status and removes the print history for ${count === 1 ? "this registration" : "these registrations"}.`
      )
    ) {
      onClick();
    }
  };

  if (selectedItems !== undefined && selectedItems.length > 0) {
    return (
      <button onClick={handleResetSelectedClick} className="danger btn btn-large btn-invisible btn-invisible-danger">
        Reset {selectedItems.length} Selected
      </button>
    );
  }
  if (showResetAll) {
    return (
      <button onClick={handleResetAllClick} className="danger btn btn-large btn-invisible btn-invisible-danger">
        Reset All
      </button>
    );
  }
  return null;
};
